export const DEFAULTS_HEADERS = [
  { key: 'title', title: 'Title' },
  { key: 'color', title: 'Color' },
];

export const COLOR_OPTIONS_MAP = {
  red: '#FF0000FF',
  green: '#008000FF',
  blue: '#0000FFFF',
  orange: '#FFA500FF',
  white: '#FFFFFFFF',
  yellow: '##FFFF00FF',
  gray: '#808080FF',
};

export const BASE_COL_WIDTH = 150;

export const getProjectAutoFillFields = (sections) => {
  const fields = [];
  sections?.forEach((section) => {
    section?.fields?.forEach((field) => {
      const { selectedType, configProps } = field ?? {};
      if (selectedType === 'dropdown' && configProps?.dataType === 'Projects') {
        fields.push(field);
      }
      if (selectedType === 'attribute' && configProps?.dataType === 'Project') {
        fields.push(field);
      }
      if (selectedType === 'dynamicAttribute' && configProps?.dataType === 'projects') {
        fields.push(field);
      }
    });
  });
  return fields;
};

export const checkProjectHasSameType = (field, project) => {
  const subDataTypeSet = new Set(field?.configProps?.subDataType ?? []);
  return subDataTypeSet.size === 0 || subDataTypeSet.has(project?.projectTypeId);
};

export const getLinkedProjectResponse = ({
  field,
  linkId,
  linkedProject,
  dynamicAttributeResponses = {},
  equipment = [],
  projectEquipment = {},
  equipmentTypeMap = {},
  divisionIds = [],
}) => {
  const { selectedType, configProps, id } = field ?? {};
  if (selectedType === 'dropdown') {
    if (checkProjectHasSameType(field, linkedProject)) {
      return {
        values: [{ id: linkId, name: linkedProject?.name || '' }],
      };
    }
  }
  if (selectedType === 'attribute') {
    // should follow similar logic as in Attributes.js
    if (configProps?.type === 'equipment') {
      const divisionSet = new Set(divisionIds);
      const assignedEquipment = equipment.filter((eq) => (
        eq.active
        && eq.divisionIds?.some((divisionId) => divisionSet.has(divisionId))
        && !!projectEquipment[linkId]?.[eq.id]
      ));
      const value = assignedEquipment.map((eq) => {
        const typeName = equipmentTypeMap[eq.equipmentTypeId]?.name;
        const typeString = typeName ? ` - ${typeName}` : '';
        return `• ${eq.name}${typeString}`;
      }).join('\n');
      return { value };
    }
    return { value: linkedProject?.[configProps?.attribute] ?? '' };
  }
  if (selectedType === 'dynamicAttribute') {
    const response = dynamicAttributeResponses[id];
    if (response) return { ...response };
  }
  return null;
};

/**
 * Returns the 4-byte Hex string of the color
 * @param {string} hex - hex color string
 * @returns {string} - 4-byte Hex string of the color
 */
export const parseHexString = (hex) => {
  if (hex.length > 9) return null;
  const hexRegex = /^#?([A-Fa-f0-9]{8}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
  if (!hexRegex.test(hex)) return null;

  let parsedHex = hex;

  // Hex looks like #...... -> we want to remove '#' for parsing
  if (hex.startsWith('#')) {
    parsedHex = hex.substring(1);
  }

  // Hex looks like #FFF -> we want to expand it to #FFFFFF and add the alpha channel
  if (parsedHex.length === 3) {
    parsedHex = parsedHex.split('').map((char) => char + char).join('');
    return `#${parsedHex.toUpperCase()}FF`;
  }

  // Hex looks like #FFFFFF -> we want to add the alpha channel
  if (parsedHex.length === 6) {
    return `#${parsedHex.toUpperCase()}FF`;
  }

  // Hex looks like #FFFFFFFF -> This is already parsed
  return `#${parsedHex.toUpperCase()}`;
};
